var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#00C853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.8096V23H19.5707V17.2242C19.5707 15.7733 19.0747 14.783 17.8334 14.783C16.8858 14.783 16.3219 15.4504 16.0738 16.0959C15.9833 16.3267 15.9601 16.6479 15.9601 16.9709V23H12.5296C12.5296 23 12.5758 13.2177 12.5296 12.2041H15.9597V13.7344C15.9528 13.7459 15.9437 13.7582 15.9372 13.7693H15.9597V13.7344C16.4154 12.9999 17.2293 11.9505 19.051 11.9505C21.308 11.9505 23 13.4935 23 16.8096ZM8.94116 7C7.76761 7 7 7.80556 7 8.86491C7 9.90116 7.7454 10.7312 8.89563 10.7312H8.91855C10.1148 10.7312 10.8588 9.90132 10.8588 8.86491C10.8363 7.80556 10.1148 7 8.94116 7ZM7.20374 23H10.6329V12.2041H7.20374V23Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.22eede5883d1632ca4c3a5d05b842939.svg";
export { ForwardRef as ReactComponent };